export default {"src":"/_next/static/image/public/images/ic_search_nodata.e14bb284b12461b32fc8fe02e1fa3c20.svg","height":80,"width":71};